<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "file" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 22 23'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M12.8337 10.5835H7.33366M9.16699 14.2502H7.33366M14.667 6.91683H7.33366M18.3337 6.7335V16.2668C18.3337 17.807 18.3337 18.577 18.0339 19.1653C17.7703 19.6827 17.3496 20.1034 16.8321 20.3671C16.2439 20.6668 15.4738 20.6668 13.9337 20.6668H8.06699C6.52685 20.6668 5.75678 20.6668 5.16852 20.3671C4.65107 20.1034 4.23038 19.6827 3.96672 19.1653C3.66699 18.577 3.66699 17.807 3.66699 16.2668V6.7335C3.66699 5.19335 3.66699 4.42328 3.96672 3.83502C4.23038 3.31758 4.65107 2.89688 5.16852 2.63323C5.75678 2.3335 6.52685 2.3335 8.06699 2.3335H13.9337C15.4738 2.3335 16.2439 2.3335 16.8321 2.63323C17.3496 2.89688 17.7703 3.31758 18.0339 3.83502C18.3337 4.42328 18.3337 5.19335 18.3337 6.7335Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>